// extracted by mini-css-extract-plugin
export default {"subContainer":"Admin_subContainer__tAbO1"};